import { render, staticRenderFns } from "./PreOrderPaymentMethod.vue?vue&type=template&id=73084560&scoped=true&"
import script from "./PreOrderPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./PreOrderPaymentMethod.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderPaymentMethod.vue?vue&type=style&index=0&id=73084560&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73084560",
  null
  
)

export default component.exports